import { Component, OnInit } from '@angular/core';
import { MainLayoutComponentBase } from '../../../classes/main-layout-component.class';
import { environment } from '@env/environment';

@Component({
  selector: 'app-client-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class default_MainLayoutComponent extends MainLayoutComponentBase implements OnInit {
  public leftCornerClasses: string[] = ['curveCorner', 'curveLeft', 'curveIsMaramataka'];
  public logoSrc = `/assets/clients/${environment.forceBrand || window.location.host.split(/\.|:/g)[0]}/logo.png`;
  public showBrandedLogo: boolean = true;
  public rongoUrl = this.buildRongoUrl();

  onTypeChange(): void {}

  onBottomNavNavigate(mode: string): void {
    if (mode === 'mapview') {
      this.openMapView();
    } else if (mode === 'maramataka') {
      this.openMaramataka();
    } else {
      this.openDashboard();
    }
  }

  /**
   * Rongo is hosted per tenant, outside the admin SPA. Keep the link in step
   * with the environment the dashboard is running in.
   */
  private buildRongoUrl(): string {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:5173';
    }

    const tenant = environment.forceBrand || host.split('.')[0];
    const environmentSegment = host.split('.').find((part) => part === 'dev' || part === 'test');
    return `https://${tenant}.rongo.${environmentSegment ? `${environmentSegment}.` : ''}thestream.nz`;
  }

  async onLoadMenuItems(): Promise<void> {
    const user = await this.authService.getLoggedInUser().toPromise();
    const sites = this.menuJSON.find((x: any) => x.name === 'Landfill sites') as any;
    sites.name = 'Sites';

    sites.children =
      user.sites?.map((site) => ({
        site,
        state: '',
        name: site.name,
        onClick: () => this.sitesService.setSelectedSite(site),
      })) || [];

    this.sitesService.getSelectedSite().subscribe((site) => {
      if (Array.isArray(sites.children)) {
        sites.children.forEach((x: any) => {
          x.state = x.site.id === site?.id ? 'active' : '';
        });
      }
    });

    const explore = this.menuJSON.find((x: any) => x.name === 'Explore') as any;

    explore.children = explore.children.map((x: any) => ({ ...x, url: '#' }));

    const information = this.menuJSON.find((x: any) => x.name === 'Information') as any;

    information.children = information.children.filter((x: any) => x.name !== 'Landfill Management Plan');
  }
}
